module.exports = __webpack_public_path__ + "static/media/film-prod-nyc-2.94afab72.jpg";